export class InvoiceHeader
{
    id:string=generateGuid();
    subTotal: number=0;
    vat: number=0;
    total: number=0
    saleTransactionDetails: InvoiceDtlItem[]=[]
      reset() {
        this.subTotal=0
        this.total=0
        this.vat=0
    }
    fixSummary()
    {
        this.subTotal=Number(this.subTotal.toFixed(2))
        this.vat=Number(this.vat.toFixed(2))
        this.total=Number(this.total.toFixed(2))
    }
}

export class InvoiceDtlItem{
    productId:number
    price:number=0;
    vat: number=0
    quantity: number=0
    name:string
    imgUrl:string
    priceIncludeVat: number=0
    id:string= generateGuid()
    saleTransactionId:string
    isEdit:boolean=false;
    vatBeforeDiscount: number=0;

}


export function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


// WEBPACK FOOTER //
// ./src/QrMena/models/qrmena-invoice-model.ts